import * as svg from "../../../assets/eye-icon.svg";

import {iconBuilder} from "./iconBuilder";

const EyeIcon = iconBuilder(svg, "EyeIcon", "0 0 14 11");

export default EyeIcon;
